import classNames from 'classnames'
import injectSheet from 'react-jss'
import style from './style'

const Badge = ({
  item,
  className,
  classes,
  color,
  order,
}) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootColorLight]: color === 'light',
        [className]: className,
      })}
    >
      <div className={classes.image}>
        {item.image && <img src={item.image} alt={item.title} />}
        {item.icon && <svg><use xlinkHref={`#ico-${item.icon}`} /></svg>}
        {order && <div className={classes.order}>{`0${order}`}</div>}
      </div>
      <div
        className={classes.info}
        dangerouslySetInnerHTML={{ __html: item.text }}
      />
    </div>
  )
}

export default injectSheet(style)(Badge)
